interface Config {
  frontendUrl: string;
  apiUrl: string;
  apiVersion: string;
  googleClientId: string;
}

const config: Config = {
  frontendUrl: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
  apiUrl: process.env.REACT_APP_API_URL || '',  // Use relative URL when API is served from same domain
  apiVersion: process.env.REACT_APP_API_VERSION || 'v1',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
};

export const getApiUrl = (endpoint: string): string => {
  return `${config.apiUrl}/api/${config.apiVersion}${endpoint}`;
};

export const getFrontendUrl = (path: string): string => {
  return `${config.frontendUrl}${path}`;
};

export default config; 